function verifyScroll() {
	var scrolled = document.body.scrollTop;

	if (scrolled > 0) {
		$('body').addClass('scrolled');
		$('.nav-fixed').addClass('active');
	} else {
		$('body').removeClass('scrolled');
		$('.nav-fixed').removeClass('active');
	}
}

document.addEventListener('scroll', function(event) {
	verifyScroll();
}, true);